import { Shield, Home, Thermometer } from "lucide-react";

const highlights = [
  {
    icon: Shield,
    title: "Fassadendämmung",
    text: "Schutz vor Witterung & Algenbefall. WDVS-Systeme für nachhaltigen Werterhalt Ihrer Immobilie."
  },
  {
    icon: Home,
    title: "Innendämmung",
    text: "Schimmelschutz mit Calciumsilikat & Holzfaser für ein gesundes, behagliches Raumklima."
  },
  {
    icon: Thermometer,
    title: "Heizkosten-Stopp",
    text: "Effiziente Dämmung für Dachboden & Kellerdecke – spürbar weniger Energiekosten."
  }
];

export const WDVSFocus = () => {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-foreground text-background">
      <div className="container mx-auto">
        <div className="max-w-3xl mb-10 md:mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-background/75 mb-4 block">
            Unser Steckenpferd
          </span>
          <h2 className="font-caslon text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Energetische Sanierung mit System: Werterhalt für Ihre Immobilie
          </h2>
          <p className="text-lg text-background/85 leading-relaxed">
            Eine Fassade ist mehr als nur Farbe. Als Experten für Wärmedämmverbundsysteme (WDVS) 
            in Herford sorgen wir dafür, dass Ihre Energie dort bleibt, wo sie hingehört: im Haus. 
            Wir beraten Sie herstellerunabhängig zu den besten Systemen – von wirtschaftlichem EPS 
            bis hin zu Hochleistungs-Resol.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-background/10 rounded-lg overflow-hidden">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="bg-foreground p-10 flex flex-col gap-6 hover:bg-secondary/10 transition-colors duration-500"
              >
                <div className="w-12 h-12 rounded-lg bg-background/10 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-background" />
                </div>
                <h3 className="font-caslon text-2xl font-bold text-background">
                  {item.title}
                </h3>
                <p className="text-background/80 leading-relaxed">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
